import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';

export class StatementsRepository {
  static async getStatements(siteIds) {


    try {
      let statements = [];
      for (const sid of siteIds) {

        const statementsQuery = query(
          collection(db, 'statements'),
          where('siteId', '==', sid),
        );
        const statementsSnapshot = await getDocs(statementsQuery);
  
        statementsSnapshot.docs.map((data) => {
          statements.push(data.data());
        });


      }
      return statements;
    } catch (error) {
      throw error;
    }
  }

}
